import React, { useMemo, useState } from 'react';
import cn from 'clsx';
import { accordion, accordionPanel } from './accordion-styles';

type AccordionProps = {
  children: React.ReactNode;
  className?: string;
  closePrevious?: boolean;
  defaultActivePanel?: string;
};

const initState = (defaultActivePanel?: string) =>
  defaultActivePanel ? { [defaultActivePanel]: true } : {};

export const Accordion: React.FC<AccordionProps> = ({
  children,
  className,
  closePrevious,
  defaultActivePanel,
}) => {
  const [panelState, setPanelState] = useState<Record<string, boolean>>(initState(defaultActivePanel));

  const elements = useMemo(() => React.Children.toArray(children), [children]);

  const handlePanelClick = (onClick?: (panelName: string, isOpen: boolean) => void) => (
    panelName: string,
    isOpen: boolean
  ) => {
    const prevCondition = panelState[panelName];
    if (closePrevious) {
      setPanelState({ [panelName]: !prevCondition });
    } else {
      setPanelState({
        ...panelState,
        [panelName]: !prevCondition,
      });
    }

    if (onClick) onClick(panelName, isOpen);
  };

  return (
    <div className={cn(className, accordion)}>
      {elements.map(element => (
        <>
          {React.isValidElement(element)
            ? React.cloneElement(element, {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-expect-error
                isOpen: panelState[element.props.name],
                onClick: handlePanelClick(element.props.onClick),
                className: cn(accordionPanel, element.props.className),
              })
            : element}
        </>
      ))}
    </div>
  );
};
